module.exports = __webpack_public_path__ + "img/chart-line-down.f221e86b.svg";